import React from "react";
import styles from "./EmptyStateComponent.module.css";

const EmptyStateComponent = ({ type, ...props }) => {
  const messages = {
    pending: "No pending videos",
    recent: "No recently generated videos",
    content: "No videos created yet"
  };
  
  const subMessages = {
    pending: "Start creating a new video to see it here",
    recent: "Complete your pending videos to see them here",
    content: "Use the search bar above to find videos once you've created them"
  };
  
  return (
    <div 
      className={styles.container} 
      data-testid={`empty-state-${type || 'unknown'}`}
      {...props}
    >
      <p className={styles.title}>{messages[type] || "No content available"}</p>
      <p className={styles.message}>{subMessages[type] || ""}</p>
    </div>
  );
};

export default EmptyStateComponent;
